import { factionTextColor } from "@/lib/factionColors";

/**
 * Tiny coloured chip showing a faction's acronym (or the first 3-5 letters of
 * its name if no acronym is set). Used in member cards, modals, admin lists.
 */
export default function FactionChip({ faction, label, size = "sm", className = "", testid }) {
  if (!faction) return null;
  const acronym = (faction.acronym || faction.name || "?").trim();
  const color = faction.color || "#5C6B51";
  const text = factionTextColor(faction.color);
  const sizes = {
    xs: { px: "6px", py: "2px", font: "9px", letter: "0.18em", border: "1px" },
    sm: { px: "8px", py: "3px", font: "10px", letter: "0.2em",  border: "1px" },
    md: { px: "10px", py: "5px", font: "11px", letter: "0.22em", border: "1.5px" },
  };
  const s = sizes[size] || sizes.sm;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-2 font-mono-ui uppercase font-semibold tracking-[var(--ft-tracking)] ${className}`}
      style={{
        background: color,
        color: text,
        padding: `${s.py} ${s.px}`,
        fontSize: s.font,
        border: `${s.border} solid rgba(0,0,0,0.35)`,
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.18)",
        // CSS variable used in tracking — avoids a Tailwind dynamic class
        ["--ft-tracking"]: s.letter,
      }}
      title={faction.name}
    >
      {acronym}
      {label && <span style={{ opacity: 0.8 }}>· {label}</span>}
    </span>
  );
}
